'use strict';

require('jquery-mousewheel/jquery.mousewheel.js');

if (!window.MPP.NearbyDealsMap) {
  window.MPP.NearbyDealsMap = {};
}

window.MPP.NearbyDealsMap.Carousel = class Carousel {
  constructor(selector, parentSelector) {
    this.selector = selector;
    this.parentSelector = parentSelector;
    this.$parent = $(this.parentSelector);
    this.$el = $(this.selector);
    this.tiles = this.$el.children('li');
    this.tileHighlightClass = 'c-bg-ntc';
    this.makeHoverable();
  }

  clearHighlight() {
    this.tiles.removeClass('highlighted');
    this.tiles.find('.tile-num').removeClass(this.tileHighlightClass);
  }

  scrollToTile(num) {
    if (!num == null || !(num <= this.tiles.length)) {
      return;
    }

    this.clearHighlight();
    const target = $(`#tile_${num}`);
    this.$parent.stop().scrollTo(target, 400);
    this.setHighlighted(target);
  }

  setHighlighted(target) {
    target.addClass('highlighted');
    target.find('.tile-num').addClass(this.tileHighlightClass);
  }

  goToDealPage(num) {
    if (num == null || !(num <= this.tiles.length)) {
      return;
    }

    const target = $(`#tile_${num}`);
    const targetDealUrl = target.find('figcaption a').attr('href');

    if (targetDealUrl != null ? targetDealUrl.length : undefined) {
      window.location = targetDealUrl;
    }
  }

  makeHoverable() {
    const that = this;
    return this.tiles.hover(
      function() {
        const tile = $(this);
        const tileNumber = tile.attr('data-tile');
        that.clearHighlight();
        that.setHighlighted(tile);
        return window.MPP.NearbyDealsMap.markers != null
          ? window.MPP.NearbyDealsMap.markers[tileNumber - 1]
              .find('.marker-label')
              .addClass('active c-txt-ntc c-bdr-ntc')
          : undefined;
      },
      function() {
        that.clearHighlight();
        const tileNumber = $(this).attr('data-tile');
        return window.MPP.NearbyDealsMap.markers != null
          ? window.MPP.NearbyDealsMap.markers[tileNumber - 1]
              .find('.marker-label')
              .removeClass('active c-txt-ntc c-bdr-ntc')
          : undefined;
      }
    );
  }
};
